import { Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Button } from 'settle-ui/components/Button/Button'
import { ProductCheckboxGroup } from 'routes/components/ProductCheckboxGroup/ProductCheckboxGroup'
import { useReCaptcha } from 'lib/hooks/useReCaptcha/useReCaptcha'
import { isAccountingFirm } from 'lib/helpers/isAccountingFirm/isAccountingFirm'
import {
  type UseProductFormSubmitParams,
  useProductFormSubmit,
} from '../../hooks/useProductFormSubmit/useProductFormSubmit'
import { BusinessTypeSelector } from './components/BusinessTypeSelector/BusinessTypeSelector'
import { WorkEmailField } from './components/WorkEmailField/WorkEmailField'

export type ProductPageFormProps = Omit<UseProductFormSubmitParams, 'reCaptcha'>

export const ProductPageForm: React.FC<ProductPageFormProps> = (props) => {
  const { t } = useTranslation()
  const reCaptcha = useReCaptcha()
  const { handleSubmit, loading } = useProductFormSubmit({ ...props, reCaptcha })

  const { businessType } = props
  const fields = isAccountingFirm(businessType)
    ? [BusinessTypeSelector, WorkEmailField, ProductCheckboxGroup]
    : [ProductCheckboxGroup, WorkEmailField]

  return (
    <Stack
      component="form"
      noValidate={true}
      onSubmit={handleSubmit}
      sx={{
        gap: 3.5,
        width: '100%',
        maxWidth: 380,
      }}
    >
      {fields.map((Field, index) => (
        <Field key={index} />
      ))}
      <Button
        type="submit"
        fullWidth={true}
        color="primary"
        variant="primary"
        loading={loading}
        data-testid="product-page-submit-button"
      >
        {t('next')}
      </Button>
    </Stack>
  )
}
